import React from 'react';
import { Drawer } from '@mui/material';
import CourtLocationForm from './CourtLocationForm';
import { ModalTitle } from 'src/components/new/modal/ModalTitle';
import { ModalFooter } from 'src/components/new/modal/ModalFooter';
import { ModalContent } from 'src/components/new/modal/ModalContent';

interface CourtLocationDialoggProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const EditCourtLocationDialog: React.FC<CourtLocationDialoggProps> = ({ open, onClose, onSubmit }) => {
  return (
    <Drawer
      open={open}
      anchor="right"
      onClose={onClose}
      sx={{
        '& .MuiPaper-root': {
          background: '#FFF',
          width: '31.25rem',
        },
      }}
    >
      <ModalTitle onClose={onClose}>Edit Court Location</ModalTitle>
      <ModalContent>
        <CourtLocationForm />
      </ModalContent>
      <ModalFooter onClose={onClose} onSubmit={onSubmit} />
    </Drawer>
  );
};

export default EditCourtLocationDialog;
